import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-batch-alert',
  templateUrl: './delete-batch-alert.component.html',
  styleUrls: ['./delete-batch-alert.component.scss']
})
export class DeleteBatchAlertComponent implements OnInit {
  deleteMsg: boolean = true;
  openPrograss: boolean = false;

  constructor(public dialog: MatDialog) { }

  ngOnInit(): void {
  }

  exitModal(){
    this.dialog.closeAll();
  }

  progressDeleted(){
    this.openPrograss = true;
    this.deleteMsg = false;
  }



}
